// @flow weak

export const defaults = {
  notificationsList: [],
};
